import axios from 'axios';

const createBackendAPI = (context: string = 'mge') => {
  const BASE_URL = `${window.location.origin}/${context}/`;

  return axios.create({
    baseURL: BASE_URL,
  });
};

export { createBackendAPI };
